var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Box, ListItem, ListItemText, Menu, MenuItem, Typography, styled, } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExternalLink from './ExternalLink';
import _ from 'lodash';
import { userInfoSelectUserInfo } from '@/store/auth/selectors';
import { ROLE, ROLE_FUNCTIONS } from '@/utils/constants';
import { useSelector } from 'react-redux';
var InternalLinkStyled = styled('div')(function () { return ({
    '& .MuiAccordion-root': {
        background: 'none',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
        margin: '12px 0px !important',
        marginBottom: '5px !important',
    },
    '& .Mui-expanded': {
        minHeight: 'unset !important',
    },
    '& .MuiAccordionDetails-root': {
        padding: '0px 0px 0px 20px',
    },
}); });
var StyledMenu = styled(function (props) { return (_jsx(Menu, __assign({ elevation: 0 }, props))); })(function (_a) {
    var theme = _a.theme;
    return ({
        '& .MuiPaper-root': {
            top: '390px !important',
            left: '80px !important',
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            background: theme.palette.common.black,
            '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 14,
                left: -4,
                width: 10,
                height: 10,
                transform: 'translateY(-50%) rotate(135deg)',
                zIndex: 0,
                background: theme.palette.common.black,
            },
            '& .MuiMenuItem-root': {
                display: 'block',
            },
        },
    });
});
var InternalLink = function (_a) {
    var menu = _a.menu, open = _a.open, itemSelected = _a.itemSelected;
    var userInfo = useSelector(userInfoSelectUserInfo);
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var openMenu = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var compareId = function (selected, parentId) {
        return selected.current.parentId == parentId;
    };
    var getCssForIcon = function (selected, parentId) {
        if (!open && compareId(selected, parentId)) {
            return {
                display: 'flex',
                borderRadius: '12px',
                backgroundColor: 'primary.lightSidebar',
            };
        }
        return {
            width: '100%',
        };
    };
    var renderNavLink = function (menuProps, _open) {
        return (_jsx(NavLink, { to: menuProps.path, id: "nav_".concat(menuProps.id), onClick: function () { return setAnchorEl(null); }, children: function (_a) {
                var isActive = _a.isActive;
                if (isActive) {
                    itemSelected.current = menuProps;
                }
                return (_jsxs(ListItem, { sx: {
                        borderRadius: '12px',
                        gap: 1.5,
                        height: '40px',
                        width: '100%',
                        backgroundColor: isActive
                            ? 'primary.lightSidebar'
                            : 'transparent',
                    }, children: [menuProps.icon ? (_jsx(Box, { sx: {
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                            }, justifyContent: "center", alignItems: "center", children: _jsx("img", { src: menuProps.icon, alt: menuProps.label, style: {
                                    color: 'text.main',
                                } }) })) : (_jsx(Box, { sx: {
                                width: 7,
                                height: 7,
                                backgroundColor: 'text.main',
                                borderRadius: '50%',
                            } })), _open && (_jsx(ListItemText, { sx: { margin: 0, color: 'text.main' }, primary: _jsx(Typography, { variant: "body1", color: 'text.main', sx: {
                                    fontWeight: isActive ? 700 : 400,
                                    display: 'inline-block',
                                    verticalAlign: 'bottom',
                                }, children: menuProps.label }) }))] }));
            } }));
    };
    var findChildMenu = function (menus) {
        if (menus[0].children) {
            return findChildMenu(menus[0].children);
        }
        else {
            return menus;
        }
    };
    var renderMenuBaseOnRole = function (menus) {
        var _a, _b, _c;
        if (!((_b = (_a = menus === null || menus === void 0 ? void 0 : menus[0]) === null || _a === void 0 ? void 0 : _a.path) === null || _b === void 0 ? void 0 : _b.includes('/')))
            return menus;
        var rs = __spreadArray([], menus, true);
        if (((_c = userInfo === null || userInfo === void 0 ? void 0 : userInfo.setting) === null || _c === void 0 ? void 0 : _c.role) !== ROLE.SUPER_ADMIN) {
            rs = rs.filter(function (x) {
                var _a, _b;
                var screen = _.replace(x.id, 'pid_cms_', '').toUpperCase();
                if (((_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.functions) === null || _a === void 0 ? void 0 : _a.includes("VIEW_".concat(screen, "S"))) ||
                    (screen === 'IMAGE_LIBRARY' &&
                        _.every([
                            ROLE_FUNCTIONS.VIEW_IMAGE_LIBRARY,
                            ROLE_FUNCTIONS.VIEW_SUB_FOLDER,
                        ], function (func) { var _a; return (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.functions) === null || _a === void 0 ? void 0 : _a.includes(func); })) ||
                    (screen === 'BROADCAST_TEXT_MESSAGE' &&
                        ((_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.functions) === null || _b === void 0 ? void 0 : _b.includes(ROLE_FUNCTIONS.VIEW_BROADCAST_TEXT_MESSAGE)))) {
                    return true;
                }
                return false;
            });
        }
        return rs;
    };
    var renderMenuItem = function (menuProps) {
        var items = findChildMenu(menuProps.children);
        // render items base on role user
        items = renderMenuBaseOnRole(items);
        var result = items.map(function (item) { return (_jsx(MenuItem, { children: renderNavLink(item, true) }, "menu_item_".concat(item.id))); });
        return result;
    };
    return (_jsx(InternalLinkStyled, { children: menu.children ? (_jsxs(Accordion, { style: { boxShadow: 'none' }, children: [_jsxs(AccordionSummary, { expandIcon: open && _jsx(ExpandMoreIcon, { style: { color: 'white' } }), "aria-controls": "panel1-content", id: "nav_".concat(menu.id), sx: __assign({}, getCssForIcon(itemSelected, menu.id)), children: [menu.icon && (_jsx(Box
                        // sx={{
                        //   ...getCssForIcon(itemSelected, menu.id),
                        // }}
                        , { 
                            // sx={{
                            //   ...getCssForIcon(itemSelected, menu.id),
                            // }}
                            justifyContent: "center", alignItems: "center", onClick: handleClick, children: _jsx("img", { src: menu.icon, alt: menu.label }) })), open && (_jsx(Typography, { variant: "body1", sx: {
                                fontWeight: 400,
                                marginLeft: 1.5,
                                color: 'text.main',
                            }, children: menu.label }))] }), open ? (_jsx(AccordionDetails, { children: renderMenuBaseOnRole(menu.children).map(function (menu) {
                        return menu.openInNew ? (_jsx(ExternalLink, { menu: menu, open: open }, "group_menuProps_".concat(menu.id))) : (_jsx(InternalLink, { menu: menu, open: open, itemSelected: itemSelected }, "group_menuProps_".concat(menu.id)));
                    }) })) : (_jsx(StyledMenu, { id: "basic-menu", anchorEl: anchorEl, open: openMenu, onClose: handleClose, anchorOrigin: { horizontal: 'right', vertical: 'top' }, children: renderMenuItem(menu) }))] })) : (renderNavLink(menu, open)) }));
};
export default InternalLink;
